import React from "react";
import { Form } from "antd";
import { useSelector } from "react-redux";
import FormModal from "components/Modal/EditFormModal";
import ModenatoePageForm from "./ModenatoePageForm";
const EditModenatoePage = () => {
  const faqProps = useSelector((state) => state.CurdR);
  const { Edit_ModeratorPage_Modal, initialValues, Loader } = faqProps;
  const [form] = Form.useForm();

  return (
    <div>
      <FormModal
        modalTitle="Edit"
        submitButtonText="Update"
        cancelButtonText="Cancel"
        editApiRequest="EditRecord"
        apiLoader="StartSpinner"
        editApiMethod="PUT"
        editApiName="editStaticPage"
        ModalName="Edit_ModeratorPage_Modal"
        confirmLoading={Loader}
        ModalType="Hide_Modal"
        visible={Edit_ModeratorPage_Modal ? Edit_ModeratorPage_Modal : false}
        initialValues={initialValues}
        width={500}
        form={form}
        recordName="moderatorPageList"
        extraFieldName="portal"
      extraFieldValue="moderator"
      >
        <ModenatoePageForm />
      </FormModal>
    </div>
  );
};

export default EditModenatoePage;
